import styled from "styled-components";

export const MainWrapper = styled.div`
  padding-inline: 50px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 12px;
`;

export const NoDataWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 60px 20px;
`;

export const NoDataTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin: 0;
`;

export const NoDataDescription = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.colors.textSecondary};
  margin: 0;
  text-align: center;
`;

export const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 0;
  background: ${props => props.theme.colors.background || '#ffffff'};
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

